/**
 * Rebuilds a URL with a different locale prefix, preserving the rest of the
 * path, the query string, and the hash.
 *
 * Replaces the fragile `pathname.replace('/${lang}', '')` pattern, which is
 * unanchored and first-match — it would corrupt a path like
 * `/en/services/en-route` (the inner "en"). This anchors strictly to the first
 * path segment, matching the same regex SEOHead uses to strip the prefix.
 *
 *   swapLangInPath('/en/shop', '?q=x', '#sec', 'da') === '/da/shop?q=x#sec'
 *   swapLangInPath('/en/services/en-route', '', '', 'da') === '/da/services/en-route'
 */
export function swapLangInPath(
  pathname: string,
  search: string,
  hash: string,
  newLang: string,
): string {
  // Strip a leading 2-letter locale segment if present (anchored to segment 1).
  // `rest` is then '' (was "/en"), '/' (was "/en/" or bare "/"), or '/shop...'.
  const rest = pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '')
  const base = `/${newLang}${rest}`
  return `${base}${search}${hash}`
}
